import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import ExemptionViewModel from "viewModels/notice/exemption/exemptionViewModel";
import { Form, Col } from "react-bootstrap";
import AdvancedSelect from "controls/advancedSelect";
import Tooltip from "controls/tooltip";

const ExemptionReasonSelect: FunctionComponent<{
  vm: ExemptionViewModel;
}> = observer(({ vm }) => {
  const labelId = "exemption-reason-label";

  return (
    <Form.Row>
      <Form.Group as={Col} sm={12}>
        <Form.Label id={labelId}>{vm.translateAttribute("reason")}</Form.Label>
        <Tooltip
          id="exemption-reasons-changed"
          placement={"top"}
          tooltip={vm.translateGeneral("reasonOptionsChanged")}
          show={vm.showTooltip}
          trigger="click">
          <AdvancedSelect
            target={vm.notice}
            isSearchable={false}
            property="exemptionReasonId"
            items={vm.reasons}
            aria-labelledby={labelId}
            mode="key"
            formatOptionLabel={(data: any) => {
              return <span dangerouslySetInnerHTML={{ __html: data.label }} />;
            }}
          />
        </Tooltip>
      </Form.Group>
    </Form.Row>
  );
});

export default ExemptionReasonSelect;
